import React, { useState } from 'react';
import { AttachMoney, Domain, LocationOn } from '@material-ui/icons';

import EditSectionForm from 'ui/form/EditSectionForm';
import Fields from 'ui/form/FieldsForm';
import PaperContainer from 'ui/PaperContainer';

export default function CompanyProfile({ init, onSubmit, canEdit }) {
    const [values, setValues] = useState(init);
    const errors = {};
    const changeFactory = name => value =>
        setValues({ ...values, [name]: value });
    const businessPreview =
        values.business_name || values.city || values.address1 ? (
            <React.Fragment>
                <div>{values.company_name}</div>
                <div>{values.vat}</div>
                <div>{values.address1}</div>
                <div>{values.city}</div>
            </React.Fragment>
        ) : (
            ''
        );

    return (
        <PaperContainer title="Company profile">
            <EditSectionForm title="Country" icon={LocationOn}>
                <EditSectionForm.Preview>
                    {values.country}
                </EditSectionForm.Preview>
            </EditSectionForm>
            <EditSectionForm title="Currency" icon={AttachMoney}>
                <EditSectionForm.Preview>
                    {values.currency}
                </EditSectionForm.Preview>
            </EditSectionForm>
            <EditSectionForm
                title="Business name and address"
                help="Business name and address help"
                icon={Domain}
                onSubmit={() => onSubmit(values)}
                canEdit={canEdit}
            >
                <EditSectionForm.Preview>
                    {businessPreview}
                </EditSectionForm.Preview>
                <EditSectionForm.Form>
                    <Fields.Text
                        label="Business name"
                        value={values.company_name}
                        error={errors.company_name}
                        onChange={changeFactory('company_name')}
                    />
                    <Fields.Text
                        label="VAT"
                        value={values.vat}
                        error={errors.vat}
                        onChange={changeFactory('vat')}
                    />
                    <Fields.Text
                        label="Address line 1"
                        value={values.address1}
                        error={errors.address1}
                        onChange={changeFactory('address1')}
                    />
                    <Fields.Text
                        label="City"
                        value={values.city}
                        error={errors.city}
                        onChange={changeFactory('city')}
                    />
                    <Fields.Text
                        label="ZIP / postal code"
                        value={values.postal_code}
                        error={errors.postal_code}
                        onChange={changeFactory('postal_code')}
                    />
                </EditSectionForm.Form>
            </EditSectionForm>
        </PaperContainer>
    );
}
